import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(30, 64, 175, 0.05), rgba(30, 64, 175, 0.05)), url('https://static.readdy.ai/image/3b71a02bb86d4e011a6e698798aa6f47/e7b7e732de148ddbc58081f96185a595.jpeg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="text-white">
            <div className="mb-6">
              <h1 className="text-5xl lg:text-6xl font-bold leading-tight mb-6">
                Nossa missão é
                <span className="text-blue-300 block">Mais eficiência, mais sabor, mais resultado.</span>
              </h1>
              <p className="text-xl text-blue-100 mb-8 leading-relaxed">
                Desenvolvemos produtos alimentícios de alta qualidade com ingredientes selecionados e tecnologia avançada. 
                Somos seu parceiro estratégico no setor de Food Service.
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Link 
                to="/produtos"
                className="inline-flex items-center justify-center px-8 py-4 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap"
              >
                Conheça Nossas Marcas
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <Link 
                to="/contato"
                className="inline-flex items-center justify-center px-8 py-4 border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-blue-600 transition-colors whitespace-nowrap"
              >
                Entre em Contato
                <i className="ri-phone-line ml-2"></i>
              </Link>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 gap-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
              <div className="text-4xl font-bold text-white mb-2">30</div>
              <div className="text-blue-200">Anos de Experiência</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
              <div className="text-4xl font-bold text-white mb-2">500+</div>
              <div className="text-blue-200">Clientes Atendidos</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
              <div className="text-4xl font-bold text-white mb-2">50+</div>
              <div className="text-blue-200">Produtos Diferentes</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center">
              <div className="text-4xl font-bold text-white mb-2">02%</div>
              <div className="text-blue-200">Taxa mínima de ruptura no ano</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white rounded-full mt-2"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;